const parseMaybeJson = (value) => {
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  if (!trimmed) return trimmed;

  if (!["{", "["].includes(trimmed[0])) {
    return value;
  }

  try {
    return JSON.parse(trimmed);
  } catch (error) {
    try {
      return JSON.parse(trimmed.replaceAll("'", '"'));
    } catch (_error) {
      return value;
    }
  }
};

export const getTermsExtraValue = (extraResponse) => {
  if (!extraResponse) return null;

  return (
    extraResponse?.data?.extra ??
    extraResponse?.extra ??
    extraResponse?.data?.data?.extra ??
    null
  );
};

const hasMeaningfulValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object") return Object.keys(value).length > 0;
  return !!value;
};

const arrayHasTermsAcceptance = (items, options) =>
  items.some((item) => isTermsAcceptedValue(item, options));

export const isTermsAcceptedValue = (rawValue, options = {}) => {
  const { hasCustomForm = false } = options;
  const value = parseMaybeJson(rawValue);

  if (!hasMeaningfulValue(value)) return false;

  if (typeof value === "string") {
    const parts = value
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.includes("terms")) return true;
    return hasCustomForm && parts.length > 0;
  }

  if (Array.isArray(value)) {
    if (value.includes("terms")) return true;
    return arrayHasTermsAcceptance(value, options) || (hasCustomForm && value.length > 0);
  }

  if (typeof value === "object") {
    if (value.accepted === true || value.terms === true) return true;
    if (isTermsAcceptedValue(value.extra, options)) return true;
    if (isTermsAcceptedValue(value.selectedOptions, options)) return true;
    if (isTermsAcceptedValue(value.checked, options)) return true;
    if (hasCustomForm && hasMeaningfulValue(value.fields ?? value.values)) {
      return true;
    }
  }

  return false;
};

export const areTermsAccepted = (extraResponse, options = {}) =>
  isTermsAcceptedValue(getTermsExtraValue(extraResponse), options);

